// extracted by mini-css-extract-plugin
export var active = "_2x-7";
export var backButton = "_2x-6";
export var clone = "_2x-c";
export var collapseBar = "_2x-h";
export var collapseMode = "_2x-j";
export var collapsed = "_2x-l";
export var dragHandle = "_2x-a";
export var dropdownIcon = "_2x-e";
export var expanding = "_2x-k";
export var hidden = "_2x-r";
export var iconContainer = "_2x-o";
export var iconSwapper = "_2x-q";
export var navItem = "_2x-4";
export var navItemIcon = "_2x-d";
export var navProfile = "_2x-5";
export var notificationCountBadge = "_2x-g";
export var notificationDot = "_2x-p";
export var optionsContainer = "_2x-f";
export var primaryNav = "_2x-0";
export var primaryTab = "_2x-m";
export var secondaryNav = "_2x-1";
export var selected = "_2x-n";
export var settingsNav = "_2x-2";
export var settingsNavItems = "_2x-3";
export var show = "_2x-b";
export var sideNav = "_2x-i";
export var teamItem = "_2x-8";
export var userProfileItem = "_2x-9";